var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.mapSize),attrs:{"id":"ksmap"}},[_c('div',{attrs:{"id":"container"}}),(_vm.showCenter)?_c('div',{attrs:{"id":"map-center"}},[_c('b-img',{attrs:{"src":_vm.centerImg,"height":"46px","width":"22px"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }